import React from "react";
import {
    Navigate } from "react-router-dom";
import OwnerDashboard from "../dashboard/OwnerDashboard";
import {
  isRoleAllowed,
  isOtherRoleAllowed,
  OTHER_ADMIN_RIGHTS,
  ROLE_VIEW,
  REPGEN
} from "../../constants/constant";

export default function ReportGeneration() {
  if (!isOtherRoleAllowed(OTHER_ADMIN_RIGHTS) && !isRoleAllowed(REPGEN, ROLE_VIEW)) {
    return <Navigate replace to="/dashboard" />;
  }
  return <OwnerDashboard reportGenerationOnly />;
}
